/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { ExperienceTaskCatalog } from './ExperienceTaskCatalog';
import {
    ExperienceTaskCatalogFromJSON,
    ExperienceTaskCatalogFromJSONTyped,
    ExperienceTaskCatalogToJSON,
    instanceOfExperienceTaskCatalog,
} from './ExperienceTaskCatalog';

/**
 * 
 * @export
 * @interface GetTaskCatalogResponseContent
 */
export interface GetTaskCatalogResponseContent {
    /**
     * Catalog groupings for every experience game studio.
     * @type {Array<ExperienceTaskCatalog>}
     * @memberof GetTaskCatalogResponseContent
     */
    experiences: Array<ExperienceTaskCatalog>;
}


/**
 * Check if a given object implements the GetTaskCatalogResponseContent interface.
 */
export function instanceOfGetTaskCatalogResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "experiences" in value;
    return isInstance;
}

export function GetTaskCatalogResponseContentFromJSON(json: any): GetTaskCatalogResponseContent {
    return GetTaskCatalogResponseContentFromJSONTyped(json, false);
}

export function GetTaskCatalogResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTaskCatalogResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'experiences': ((json['experiences'] as Array<any>).map(ExperienceTaskCatalogFromJSON)),
    };
}

export function GetTaskCatalogResponseContentToJSON(value?: GetTaskCatalogResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'experiences': ((value.experiences as Array<any>).map(ExperienceTaskCatalogToJSON)),
    };
}

